import darkThemeImage from '../../resources/images/darkTheme.webp';
import lightThemeImage from '../../resources/images/lightTheme.webp';
import {} from './changeThemeButton.css';

export default function ChangeThemeButton() 
{
  return <span onClick={() => ChangeTheme()}><img src={darkThemeImage} className='changeThemeButton' alt="change light/dark theme"></img></span>;
}

function ChangeTheme()
{
  let root = document.getElementsByClassName('App-header');
  let app = document.getElementsByClassName('App');
  let body = document.getElementsByTagName('body');

  if(root[0].style.backgroundColor === "rgb(205, 189, 238)")
  {
    root[0].style.backgroundColor = '#282c34';
    root[0].style.color = '#cdbdee';
  }
  else
  {
    root[0].style.backgroundColor = '#cdbdee';
    root[0].style.color = '#282c34';
  }

  app[0].style.backgroundColor = root[0].style.backgroundColor;
  app[0].style.color = root[0].style.color;
  body[0].style.backgroundColor = root[0].style.backgroundColor;
  ChangeButtonBackgroundColor(root[0].style.backgroundColor);
}

function ChangeButtonBackgroundColor(rootBackgroundColor){
  let changeThemeButton = document.getElementsByClassName('changeThemeButton');
  let button = changeThemeButton[0];
  if(rootBackgroundColor === "rgb(205, 189, 238)")
  {
    button.style.backgroundColor = '#282c34';
    button.src = lightThemeImage;
  }
  else
  {
    button.style.backgroundColor = '#cdbdee';
    button.src = darkThemeImage;
  }
}